_ = require 'underscore'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
t = require('app/scripts/views/internal/teacup-with-helpers')('plugin_section')
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

template = t.renderable ({ icon, text, url, subtext, thumbnail, idPlugin, actions }) ->
  t.a '.comment-unfurl.js-comment-unfurl', {
    href: url
    title: text
    rel: 'noopener noreferrer'
    target: '_blank'
  }, ->
    t.div '.comment-unfurl-thumb',
      style: t.stylify
        'background-image': if thumbnail then t.urlify(thumbnail)
        else if icon then t.urlify(icon)
        else t.urlify(PluginIOCache.fromId(idPlugin).icon.url)
        'background-size': if thumbnail then 'cover' else 'auto 40px'
    t.div '.comment-unfurl-meta', ->
      t.span '.comment-unfurl-title', ->
        t.text text
      t.span '.comment-unfurl-subtext', title: subtext, ->
        t.text subtext
      t.div '.comment-unfurl-media', ->
        t.div '.comment-unfurl-plugin-icon', ->
          t.img src: icon
          t.span '.comment-unfurl-plugin-name', ->
            t.text PluginIOCache.fromId(idPlugin).name
        t.div '.comment-unfurl-button-block', ->
          actions?.map (action, i) -> t.button '.js-comment-preview-button',
            'data-index': i, title: action.text,
            action.text
  return

module.exports = class CommentUnfurlPreview extends PluginView

  initialize: ({ @commentUnfurl }) ->
    @retain(@commentUnfurl)

  render: =>
    @$el.html(template(@commentUnfurl))
    @

  events:
    'click .js-comment-unfurl': 'clickCommentUnfurl'
    'click .js-comment-preview-button': 'executeActionCallback'

  clickCommentUnfurl: (e) ->
    if _.isFunction(@commentUnfurl.callback)
      e.preventDefault()
      @commentUnfurl.callback
        el: e.currentTarget

  executeActionCallback: (e) ->
    e.stopPropagation()
    index = parseInt(@$(e.currentTarget).attr('data-index'), 10)
    action = @commentUnfurl.actions[index]
    sendPluginUIEvent(@commentUnfurl.idPlugin, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'unfurlActionButton'
      objectType: 'powerUp'
      objectId: @commentUnfurl.idPlugin
    })
    if action.callback?
      e.preventDefault()
      action.callback
        el: e.currentTarget
